module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_maedori_02@3x-7298433b15ff9271260e9d0c9ede6744.webp";